// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("../../../../v5/common/Components/Form.bs.js");
let React = require("react");
let View__Jsx3 = require("../../helpers/View__Jsx3.bs.js");
let Form__Label = require("../../../../v5/common/Components/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let Colors = require("uikit/styles/colors");
let ReactStripeJs = require("@stripe/react-stripe-js");

function MakeStripeElement(StripeElement) {
  let stripeErrorFromJs = s => {
    switch (s) {
      case "incomplete_cvc" :
        return "IncompleteCVC";
      case "incomplete_expiry" :
        return "IncompleteExpiry";
      case "incomplete_number" :
        return "IncompleteCardNumber";
      case "invalid_expiry_month_past" :
        return "ExpiryMonthPast";
      case "invalid_expiry_year" :
        return "InvalidExpiryYear";
      case "invalid_expiry_year_past" :
        return "ExpiryYearPast";
      case "invalid_number" :
        return "InvalidCardNumber";
      default:
        return;
    }
  };
  let elementsStyle = {
    base: {
      fontSize: "14px",
      fontWeight: "400",
      color: Colors.black
    },
    complete: {
      color: Colors.black
    },
    invalid: {
      color: Colors.black
    }
  };
  let wrapperStyle = (focused, inputState) => {
    let tmp;
    if (focused) {
      tmp = Colors.goldTips;
    } else if (typeof inputState !== "object") {
      switch (inputState) {
        case "Empty" :
        case "InProgress" :
          tmp = Colors.alto;
          break;
        case "Complete" :
          tmp = Colors.chelseaCucumber;
          break;
      }
    } else {
      tmp = Colors.crimson;
    }
    return {
      borderColor: tmp,
      borderStyle: "solid",
      borderWidth: "1px",
      padding: "10px 14px",
      transition: "150ms"
    };
  };
  let Stripe__Components$MakeStripeElement = props => {
    let onValidationChange = props.onValidationChange;
    let labelText = props.labelText;
    let match = React.useReducer((state, action) => {
      if (action.TAG === "SetInputState") {
        return {
          inputState: action._0,
          focused: state.focused
        };
      } else {
        return {
          inputState: state.inputState,
          focused: action._0
        };
      }
    }, {
      inputState: "Empty",
      focused: false
    });
    let dispatch = match[1];
    let match$1 = match[0];
    let inputState = match$1.inputState;
    React.useEffect(() => {
      if (onValidationChange !== undefined) {
        if (typeof inputState !== "object" && inputState === "Complete") {
          onValidationChange(true);
        } else {
          onValidationChange(false);
        }
      }
    }, [
      inputState,
      onValidationChange
    ]);
    let tmp;
    if (typeof inputState !== "object") {
      tmp = null;
    } else {
      let error = inputState._0;
      tmp = JsxRuntime.jsx(Form.$$Error.make, {
        children: typeof error === "object" ? "Please use one of the cards shown above" : (
            error === "IncompleteCardNumber" ? "Enter a 16-digit number" : (
                error === "IncompleteExpiry" ? "Enter a complete expiration date" : (
                    error === "InvalidExpiry" || error === "InvalidExpiryYear" ? "Enter a valid expiration date" : (
                        error === "InvalidCardNumber" ? "Enter a valid credit card number" : (
                            error === "IncompleteCVC" ? "Enter a valid security code" : (
                                error === "Unknown" ? "Uknown problem" : "This expiration date has passed"
                              )
                          )
                      )
                  )
              )
          )
      });
    }
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        labelText !== undefined ? JsxRuntime.jsx(View__Jsx3.View.make, {
            mb: "sm",
            children: JsxRuntime.jsx(Form__Label.make, {
              labelText: labelText,
              optionalText: props.optionalText
            })
          }) : null,
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(StripeElement.make, {
            onFocus: () => dispatch({
              TAG: "SetFocused",
              _0: true
            }),
            onBlur: () => dispatch({
              TAG: "SetFocused",
              _0: false
            }),
            onChange: changeObject => {
              let match = changeObject.complete;
              let inputState;
              if (match) {
                if (changeObject.cardElementType === "cardNumber") {
                  let brand = changeObject.brand;
                  if (brand !== undefined) {
                    switch (brand) {
                      case "amex" :
                      case "discover" :
                      case "mastercard" :
                      case "visa" :
                        inputState = "Complete";
                        break;
                      default:
                        inputState = {
                          TAG: "Error",
                          _0: {
                            NAME: "UnsupportedCard",
                            VAL: brand
                          }
                        };
                    }
                  } else {
                    inputState = {
                      TAG: "Error",
                      _0: {
                        NAME: "UnsupportedCard",
                        VAL: "unknown"
                      }
                    };
                  }
                } else {
                  inputState = "Complete";
                }
              } else if (changeObject.empty) {
                inputState = "Empty";
              } else {
                let error = Stdlib_Option.map(Primitive_option.fromNullable(changeObject.error), error => error.code);
                if (error !== undefined) {
                  let e = stripeErrorFromJs(error);
                  inputState = e !== undefined ? ({
                      TAG: "Error",
                      _0: e
                    }) : ({
                      TAG: "Error",
                      _0: "Unknown"
                    });
                } else {
                  inputState = "InProgress";
                }
              }
              dispatch({
                TAG: "SetInputState",
                _0: inputState
              });
            },
            style: Primitive_option.some(elementsStyle),
            placeholder: props.placeholder
          }),
          style: wrapperStyle(match$1.focused, inputState)
        }),
        tmp
      ]
    });
  };
  return {
    stripeErrorFromJs: stripeErrorFromJs,
    elementsStyle: elementsStyle,
    wrapperStyle: wrapperStyle,
    make: Stripe__Components$MakeStripeElement
  };
}

let StripeElement = {
  make: ReactStripeJs.CardNumberElement
};

function stripeErrorFromJs(s) {
  switch (s) {
    case "incomplete_cvc" :
      return "IncompleteCVC";
    case "incomplete_expiry" :
      return "IncompleteExpiry";
    case "incomplete_number" :
      return "IncompleteCardNumber";
    case "invalid_expiry_month_past" :
      return "ExpiryMonthPast";
    case "invalid_expiry_year" :
      return "InvalidExpiryYear";
    case "invalid_expiry_year_past" :
      return "ExpiryYearPast";
    case "invalid_number" :
      return "InvalidCardNumber";
    default:
      return;
  }
}

let elementsStyle = {
  base: {
    fontSize: "14px",
    fontWeight: "400",
    color: Colors.black
  },
  complete: {
    color: Colors.black
  },
  invalid: {
    color: Colors.black
  }
};

function wrapperStyle(focused, inputState) {
  let tmp;
  if (focused) {
    tmp = Colors.goldTips;
  } else if (typeof inputState !== "object") {
    switch (inputState) {
      case "Empty" :
      case "InProgress" :
        tmp = Colors.alto;
        break;
      case "Complete" :
        tmp = Colors.chelseaCucumber;
        break;
    }
  } else {
    tmp = Colors.crimson;
  }
  return {
    borderColor: tmp,
    borderStyle: "solid",
    borderWidth: "1px",
    padding: "10px 14px",
    transition: "150ms"
  };
}

function Stripe__Components$MakeStripeElement(props) {
  let onValidationChange = props.onValidationChange;
  let labelText = props.labelText;
  let match = React.useReducer((state, action) => {
    if (action.TAG === "SetInputState") {
      return {
        inputState: action._0,
        focused: state.focused
      };
    } else {
      return {
        inputState: state.inputState,
        focused: action._0
      };
    }
  }, {
    inputState: "Empty",
    focused: false
  });
  let dispatch = match[1];
  let match$1 = match[0];
  let inputState = match$1.inputState;
  React.useEffect(() => {
    if (onValidationChange !== undefined) {
      if (typeof inputState !== "object" && inputState === "Complete") {
        onValidationChange(true);
      } else {
        onValidationChange(false);
      }
    }
  }, [
    inputState,
    onValidationChange
  ]);
  let tmp;
  if (typeof inputState !== "object") {
    tmp = null;
  } else {
    let error = inputState._0;
    tmp = JsxRuntime.jsx(Form.$$Error.make, {
      children: typeof error === "object" ? "Please use one of the cards shown above" : (
          error === "IncompleteCardNumber" ? "Enter a 16-digit number" : (
              error === "IncompleteExpiry" ? "Enter a complete expiration date" : (
                  error === "InvalidExpiry" || error === "InvalidExpiryYear" ? "Enter a valid expiration date" : (
                      error === "InvalidCardNumber" ? "Enter a valid credit card number" : (
                          error === "IncompleteCVC" ? "Enter a valid security code" : (
                              error === "Unknown" ? "Uknown problem" : "This expiration date has passed"
                            )
                        )
                    )
                )
            )
        )
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      labelText !== undefined ? JsxRuntime.jsx(View__Jsx3.View.make, {
          mb: "sm",
          children: JsxRuntime.jsx(Form__Label.make, {
            labelText: labelText,
            optionalText: props.optionalText
          })
        }) : null,
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(StripeElement.make, {
          onFocus: () => dispatch({
            TAG: "SetFocused",
            _0: true
          }),
          onBlur: () => dispatch({
            TAG: "SetFocused",
            _0: false
          }),
          onChange: changeObject => {
            let match = changeObject.complete;
            let inputState;
            if (match) {
              if (changeObject.cardElementType === "cardNumber") {
                let brand = changeObject.brand;
                if (brand !== undefined) {
                  switch (brand) {
                    case "amex" :
                    case "discover" :
                    case "mastercard" :
                    case "visa" :
                      inputState = "Complete";
                      break;
                    default:
                      inputState = {
                        TAG: "Error",
                        _0: {
                          NAME: "UnsupportedCard",
                          VAL: brand
                        }
                      };
                  }
                } else {
                  inputState = {
                    TAG: "Error",
                    _0: {
                      NAME: "UnsupportedCard",
                      VAL: "unknown"
                    }
                  };
                }
              } else {
                inputState = "Complete";
              }
            } else if (changeObject.empty) {
              inputState = "Empty";
            } else {
              let error = Stdlib_Option.map(Primitive_option.fromNullable(changeObject.error), error => error.code);
              if (error !== undefined) {
                let e = stripeErrorFromJs(error);
                inputState = e !== undefined ? ({
                    TAG: "Error",
                    _0: e
                  }) : ({
                    TAG: "Error",
                    _0: "Unknown"
                  });
              } else {
                inputState = "InProgress";
              }
            }
            dispatch({
              TAG: "SetInputState",
              _0: inputState
            });
          },
          style: Primitive_option.some(elementsStyle),
          placeholder: props.placeholder
        }),
        style: wrapperStyle(match$1.focused, inputState)
      }),
      tmp
    ]
  });
}

let CardNumberElement = {
  stripeErrorFromJs: stripeErrorFromJs,
  elementsStyle: elementsStyle,
  wrapperStyle: wrapperStyle,
  make: Stripe__Components$MakeStripeElement
};

let StripeElement$1 = {
  make: ReactStripeJs.CardExpiryElement
};

function stripeErrorFromJs$1(s) {
  switch (s) {
    case "incomplete_cvc" :
      return "IncompleteCVC";
    case "incomplete_expiry" :
      return "IncompleteExpiry";
    case "incomplete_number" :
      return "IncompleteCardNumber";
    case "invalid_expiry_month_past" :
      return "ExpiryMonthPast";
    case "invalid_expiry_year" :
      return "InvalidExpiryYear";
    case "invalid_expiry_year_past" :
      return "ExpiryYearPast";
    case "invalid_number" :
      return "InvalidCardNumber";
    default:
      return;
  }
}

let elementsStyle$1 = {
  base: {
    fontSize: "14px",
    fontWeight: "400",
    color: Colors.black
  },
  complete: {
    color: Colors.black
  },
  invalid: {
    color: Colors.black
  }
};

function wrapperStyle$1(focused, inputState) {
  let tmp;
  if (focused) {
    tmp = Colors.goldTips;
  } else if (typeof inputState !== "object") {
    switch (inputState) {
      case "Empty" :
      case "InProgress" :
        tmp = Colors.alto;
        break;
      case "Complete" :
        tmp = Colors.chelseaCucumber;
        break;
    }
  } else {
    tmp = Colors.crimson;
  }
  return {
    borderColor: tmp,
    borderStyle: "solid",
    borderWidth: "1px",
    padding: "10px 14px",
    transition: "150ms"
  };
}

function Stripe__Components$MakeStripeElement$1(props) {
  let onValidationChange = props.onValidationChange;
  let labelText = props.labelText;
  let match = React.useReducer((state, action) => {
    if (action.TAG === "SetInputState") {
      return {
        inputState: action._0,
        focused: state.focused
      };
    } else {
      return {
        inputState: state.inputState,
        focused: action._0
      };
    }
  }, {
    inputState: "Empty",
    focused: false
  });
  let dispatch = match[1];
  let match$1 = match[0];
  let inputState = match$1.inputState;
  React.useEffect(() => {
    if (onValidationChange !== undefined) {
      if (typeof inputState !== "object" && inputState === "Complete") {
        onValidationChange(true);
      } else {
        onValidationChange(false);
      }
    }
  }, [
    inputState,
    onValidationChange
  ]);
  let tmp;
  if (typeof inputState !== "object") {
    tmp = null;
  } else {
    let error = inputState._0;
    tmp = JsxRuntime.jsx(Form.$$Error.make, {
      children: typeof error === "object" ? "Please use one of the cards shown above" : (
          error === "IncompleteCardNumber" ? "Enter a 16-digit number" : (
              error === "IncompleteExpiry" ? "Enter a complete expiration date" : (
                  error === "InvalidExpiry" || error === "InvalidExpiryYear" ? "Enter a valid expiration date" : (
                      error === "InvalidCardNumber" ? "Enter a valid credit card number" : (
                          error === "IncompleteCVC" ? "Enter a valid security code" : (
                              error === "Unknown" ? "Uknown problem" : "This expiration date has passed"
                            )
                        )
                    )
                )
            )
        )
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      labelText !== undefined ? JsxRuntime.jsx(View__Jsx3.View.make, {
          mb: "sm",
          children: JsxRuntime.jsx(Form__Label.make, {
            labelText: labelText,
            optionalText: props.optionalText
          })
        }) : null,
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(StripeElement$1.make, {
          onFocus: () => dispatch({
            TAG: "SetFocused",
            _0: true
          }),
          onBlur: () => dispatch({
            TAG: "SetFocused",
            _0: false
          }),
          onChange: changeObject => {
            let match = changeObject.complete;
            let inputState;
            if (match) {
              if (changeObject.cardElementType === "cardNumber") {
                let brand = changeObject.brand;
                if (brand !== undefined) {
                  switch (brand) {
                    case "amex" :
                    case "discover" :
                    case "mastercard" :
                    case "visa" :
                      inputState = "Complete";
                      break;
                    default:
                      inputState = {
                        TAG: "Error",
                        _0: {
                          NAME: "UnsupportedCard",
                          VAL: brand
                        }
                      };
                  }
                } else {
                  inputState = {
                    TAG: "Error",
                    _0: {
                      NAME: "UnsupportedCard",
                      VAL: "unknown"
                    }
                  };
                }
              } else {
                inputState = "Complete";
              }
            } else if (changeObject.empty) {
              inputState = "Empty";
            } else {
              let error = Stdlib_Option.map(Primitive_option.fromNullable(changeObject.error), error => error.code);
              if (error !== undefined) {
                let e = stripeErrorFromJs$1(error);
                inputState = e !== undefined ? ({
                    TAG: "Error",
                    _0: e
                  }) : ({
                    TAG: "Error",
                    _0: "Unknown"
                  });
              } else {
                inputState = "InProgress";
              }
            }
            dispatch({
              TAG: "SetInputState",
              _0: inputState
            });
          },
          style: Primitive_option.some(elementsStyle$1),
          placeholder: props.placeholder
        }),
        style: wrapperStyle$1(match$1.focused, inputState)
      }),
      tmp
    ]
  });
}

let CardExpiryElement = {
  stripeErrorFromJs: stripeErrorFromJs$1,
  elementsStyle: elementsStyle$1,
  wrapperStyle: wrapperStyle$1,
  make: Stripe__Components$MakeStripeElement$1
};

let StripeElement$2 = {
  make: ReactStripeJs.CardCvcElement
};

function stripeErrorFromJs$2(s) {
  switch (s) {
    case "incomplete_cvc" :
      return "IncompleteCVC";
    case "incomplete_expiry" :
      return "IncompleteExpiry";
    case "incomplete_number" :
      return "IncompleteCardNumber";
    case "invalid_expiry_month_past" :
      return "ExpiryMonthPast";
    case "invalid_expiry_year" :
      return "InvalidExpiryYear";
    case "invalid_expiry_year_past" :
      return "ExpiryYearPast";
    case "invalid_number" :
      return "InvalidCardNumber";
    default:
      return;
  }
}

let elementsStyle$2 = {
  base: {
    fontSize: "14px",
    fontWeight: "400",
    color: Colors.black
  },
  complete: {
    color: Colors.black
  },
  invalid: {
    color: Colors.black
  }
};

function wrapperStyle$2(focused, inputState) {
  let tmp;
  if (focused) {
    tmp = Colors.goldTips;
  } else if (typeof inputState !== "object") {
    switch (inputState) {
      case "Empty" :
      case "InProgress" :
        tmp = Colors.alto;
        break;
      case "Complete" :
        tmp = Colors.chelseaCucumber;
        break;
    }
  } else {
    tmp = Colors.crimson;
  }
  return {
    borderColor: tmp,
    borderStyle: "solid",
    borderWidth: "1px",
    padding: "10px 14px",
    transition: "150ms"
  };
}

function Stripe__Components$MakeStripeElement$2(props) {
  let onValidationChange = props.onValidationChange;
  let labelText = props.labelText;
  let match = React.useReducer((state, action) => {
    if (action.TAG === "SetInputState") {
      return {
        inputState: action._0,
        focused: state.focused
      };
    } else {
      return {
        inputState: state.inputState,
        focused: action._0
      };
    }
  }, {
    inputState: "Empty",
    focused: false
  });
  let dispatch = match[1];
  let match$1 = match[0];
  let inputState = match$1.inputState;
  React.useEffect(() => {
    if (onValidationChange !== undefined) {
      if (typeof inputState !== "object" && inputState === "Complete") {
        onValidationChange(true);
      } else {
        onValidationChange(false);
      }
    }
  }, [
    inputState,
    onValidationChange
  ]);
  let tmp;
  if (typeof inputState !== "object") {
    tmp = null;
  } else {
    let error = inputState._0;
    tmp = JsxRuntime.jsx(Form.$$Error.make, {
      children: typeof error === "object" ? "Please use one of the cards shown above" : (
          error === "IncompleteCardNumber" ? "Enter a 16-digit number" : (
              error === "IncompleteExpiry" ? "Enter a complete expiration date" : (
                  error === "InvalidExpiry" || error === "InvalidExpiryYear" ? "Enter a valid expiration date" : (
                      error === "InvalidCardNumber" ? "Enter a valid credit card number" : (
                          error === "IncompleteCVC" ? "Enter a valid security code" : (
                              error === "Unknown" ? "Uknown problem" : "This expiration date has passed"
                            )
                        )
                    )
                )
            )
        )
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      labelText !== undefined ? JsxRuntime.jsx(View__Jsx3.View.make, {
          mb: "sm",
          children: JsxRuntime.jsx(Form__Label.make, {
            labelText: labelText,
            optionalText: props.optionalText
          })
        }) : null,
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(StripeElement$2.make, {
          onFocus: () => dispatch({
            TAG: "SetFocused",
            _0: true
          }),
          onBlur: () => dispatch({
            TAG: "SetFocused",
            _0: false
          }),
          onChange: changeObject => {
            let match = changeObject.complete;
            let inputState;
            if (match) {
              if (changeObject.cardElementType === "cardNumber") {
                let brand = changeObject.brand;
                if (brand !== undefined) {
                  switch (brand) {
                    case "amex" :
                    case "discover" :
                    case "mastercard" :
                    case "visa" :
                      inputState = "Complete";
                      break;
                    default:
                      inputState = {
                        TAG: "Error",
                        _0: {
                          NAME: "UnsupportedCard",
                          VAL: brand
                        }
                      };
                  }
                } else {
                  inputState = {
                    TAG: "Error",
                    _0: {
                      NAME: "UnsupportedCard",
                      VAL: "unknown"
                    }
                  };
                }
              } else {
                inputState = "Complete";
              }
            } else if (changeObject.empty) {
              inputState = "Empty";
            } else {
              let error = Stdlib_Option.map(Primitive_option.fromNullable(changeObject.error), error => error.code);
              if (error !== undefined) {
                let e = stripeErrorFromJs$2(error);
                inputState = e !== undefined ? ({
                    TAG: "Error",
                    _0: e
                  }) : ({
                    TAG: "Error",
                    _0: "Unknown"
                  });
              } else {
                inputState = "InProgress";
              }
            }
            dispatch({
              TAG: "SetInputState",
              _0: inputState
            });
          },
          style: Primitive_option.some(elementsStyle$2),
          placeholder: props.placeholder
        }),
        style: wrapperStyle$2(match$1.focused, inputState)
      }),
      tmp
    ]
  });
}

let CardCVCElement = {
  stripeErrorFromJs: stripeErrorFromJs$2,
  elementsStyle: elementsStyle$2,
  wrapperStyle: wrapperStyle$2,
  make: Stripe__Components$MakeStripeElement$2
};

let View;

exports.View = View;
exports.MakeStripeElement = MakeStripeElement;
exports.CardNumberElement = CardNumberElement;
exports.CardExpiryElement = CardExpiryElement;
exports.CardCVCElement = CardCVCElement;
/* StripeElement Not a pure module */
